/**
 * Web no-op: the browser Cache API stores responses atomically, so
 * partial/corrupt entries don't occur. Returning true skips verification
 * cleanly without forcing callers to branch on platform.
 */
export async function verifyVideoFile(
  _uri: string,
  _expectedHash: string,
): Promise<boolean> {
  return true;
}
